<!--
 * @Descripttion: 
 * @version: 
 * @Author: kBank
 * @Date: 2023-01-10 10:06:57
-->
<template>
  <div class="page">
    <div class="page-title">{{ $t("fn_053") }}</div>
    <img class="local" src="../assets/images/local.gif" alt="" />
    <!-- <div class="videoContainer">
      <video class="fullscreenVideo"
             id="bgVid"
             playsinline=""
             autoplay=""
             muted=""
             loop="">
        <source src="../assets/video/loginBgd.mp4"
                type="video/mp4">
      </video>
    </div> -->
    <!-- <div class="title">{{ $t('w_0001') }}</div> -->
    <div class="lang-wrap">
      <el-dropdown placement="top-start">
        <span class="el-dropdown-link">
          <span class="lang-active-name">{{ selLabl }}</span>
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown" class="user-dropdown">
          <el-dropdown-item v-for="(item, index) in languageList" :key="index">
            <div @click="setLanguage(item)">{{ item.label }}</div>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <div class="kuang">
      <div class="tit1">{{ $t("w_0007") }}</div>
      <el-form
        :model="loginForm"
        :rules="rules"
        ref="loginForm"
        label-position="top"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item :label="$t('N_I_124')" prop="username"
          ><el-input
            :placeholder="$t('N_I_124')"
            v-model="loginForm.username"
          ></el-input
        ></el-form-item>
        <el-form-item :label="$t('w_0041')" class="pr" prop="password">
          <el-input
            v-model="loginForm.password"
            type="password"
            show-password
            :placeholder="$t('w_0041')"
            @keyup.enter.native="handleLogin"
          >
            <!-- <i slot="suffix"
               class="el-input__icon el-icon-view"></i> -->
          </el-input>
          <!-- 忘记密码暂时隐藏-->
          <!-- <div class="pa" @click="forGet">{{ $t('w_0042') }}</div> -->
        </el-form-item>

        <el-form-item prop="code" :label="$t('w_0043')">
          <el-input
            v-model="loginForm.code"
            :placeholder="$t('w_0043')"
            style="width: 63%"
            @keyup.enter.native="handleLogin"
          ></el-input>
          <div class="login-code">
            <img :src="codeUrl" @click="getCode" class="login-code-img" />
          </div>
        </el-form-item>
      </el-form>
      <el-button
        type="primary"
        class="sumBtn"
        :loading="fullscreenLoading"
        @click="handleLogin"
        >{{ $t("w_0044") }}</el-button
      >
    </div>
    <el-dialog
      :title="$t('w_0045')"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="35%"
      center
    >
      <div class="changePwd">
        <el-form
          ref="loginObj"
          :model="loginObj"
          :rules="rulesObj"
          label-width="80px"
        >
          <el-row :gutter="20">
            <el-col :span="16">
              <el-form-item :label="$t('N_I_124')" prop="memberCode"
                ><el-input
                  :placeholder="$t('w_0046')"
                  v-model="loginObj.memberCode"
                ></el-input
              ></el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="16">
              <el-form-item :label="$t('w_0047')" prop="newPassword">
                <el-input
                  v-model="loginObj.newPassword"
                  :type="flag1 ? 'text' : 'password'"
                  style="border: 1px solid #fff"
                  :placeholder="$t('w_0048')"
                >
                  <i
                    slot="suffix"
                    :class="[flag1 ? 'el-icon-minus' : 'el-icon-view']"
                    style="font-size: 18px"
                    autocomplete="auto"
                    @click="flag1 = !flag1"
                  />
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" class="righTxt">{{ $t("w_0049") }}</el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="16">
              <el-form-item :label="$t('MN_F_30')" prop="loginPassword">
                <el-input
                  v-model="loginObj.loginPassword"
                  :type="flag2 ? 'text' : 'password'"
                  style="border: 1px solid #fff"
                  :placeholder="$t('MN_F_30')"
                >
                  <i
                    slot="suffix"
                    :class="[flag2 ? 'el-icon-minus' : 'el-icon-view']"
                    style="font-size: 18px"
                    autocomplete="auto"
                    @click="flag2 = !flag2"
                  />
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" class="righTxt">{{ $t("w_0050") }}</el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="16">
              <el-form-item :label="$t('w_0052')" prop="phone"
                ><el-input
                  :placeholder="$t('w_0053')"
                  v-model="loginObj.phone"
                ></el-input
              ></el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="16">
              <el-form-item :label="$t('w_0043') + ':'" prop="code">
                <el-input v-model="loginObj.code" :placeholder="$t('w_0043')">
                  <i
                    slot="suffix"
                    @click="submitForm('loginObj')"
                    class="hqyzm1"
                    :class="isSend ? 'hui' : ''"
                    >{{ getSmsCode }}</i
                  >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{
          $t("ENU_P_TYPE0")
        }}</el-button>
        <el-button
          style="color: #fff; background: #cb2b2b"
          @click="submitLoginObj('loginObj')"
          >{{ $t("w_0035") }}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as api from "@/api/goods.js";
import { getCodeImg, forgetPwd, forgetSms } from "@/api/login";

export default {
  data() {
    let validatePwd = (rule, value, callback) => {
      if (this.loginObj.newPassword != value) {
        callback(new Error(this.$t("w_0054")));
      } else {
        callback();
      }
    };
    return {
      fullscreenLoading: false,
      isSend: false,
      getSmsCode: this.$t("w_0055"),
      beginTime: 60,
      timer: "",
      loginObj: {},
      dialogVisible: false,
      flag1: false,
      flag2: false,
      loginForm: {
        username: "",
        password: "",
      },
      rules: {
        username: [
          { required: true, trigger: "blur", message: this.$t("w_0046") },
        ],
        password: [
          { required: true, trigger: "blur", message: this.$t("w_0056") },
        ],
        code: [
          { required: true, trigger: "change", message: this.$t("w_0057") },
        ],
      },
      rulesObj: {
        memberCode: [
          { required: true, trigger: "blur", message: this.$t("w_0046") },
        ],
        newPassword: [
          { required: true, trigger: "blur", message: this.$t("w_0048") },
        ],
        loginPassword: [{ validator: validatePwd, trigger: "blur" }],
        phone: [
          { required: true, trigger: "blur", message: this.$t("w_0053") },
        ],
      },
      codeUrl: "",
      selLabl: "",
      languageList: [],
    };
  },
  created() {
    this.getCode();
    this.getLanguages();
  },
  methods: {
    // 语言
    getLanguages() {
      api.getLanguages().then((res) => {
        if (res.code == 200) {
          res.data.forEach((item) => {
            if (item.field == localStorage.getItem("lang")) {
              this.selLabl = item.label;
            }
          });
          if (
            localStorage.getItem("lang") == undefined ||
            localStorage.getItem("lang") == "undefined"
          ) {
            localStorage.setItem("lang", "en-US");
          }
          this.languageList = res.data;
        }
      });
    },
    setLanguage(item) {
      localStorage.setItem("lang", item.field);
      this.selLabl = item.label;
      this.$i18n.locale = item.field;
      // location.reload();
    },
    // 绑卡获取验证码
    submitForm(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.startTime();
          forgetSms(this.loginObj)
            .then((res) => {
              // this.bankCode = res.data
            })
            .catch((err) => {
              this.beginTime = 0;
            });
        } else {
          return false;
        }
      });
    },
    startTime() {
      if (this.isSend) return;
      this.isSend = true;
      this.getSmsCode = this.beginTime + this.$t("w_0058");
      let that = this;
      this.timer = setInterval(() => {
        this.beginTime--;
        this.getSmsCode = this.beginTime + this.$t("w_0058");
        if (this.beginTime < 0) {
          clearInterval(this.timer);
          this.getSmsCode = this.$t("w_0055");
          this.beginTime = 60;
          this.isSend = false;
        }
      }, 1000);
    },
    submitLoginObj(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          forgetPwd(this.loginObj)
            .then((res) => {
              this.$message({
                message: res.msg,
                type: "success",
              });
              this.dialogVisible = false;
            })
            .catch((err) => {});
        } else {
          return false;
        }
      });
    },
    forGet() {
      this.dialogVisible = true;
    },
    getCode() {
      getCodeImg().then((res) => {
        this.codeUrl = "data:image/gif;base64," + res.img;
        this.loginForm.uuid = res.uuid;
      });
    },
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.fullscreenLoading = true;
          this.$store
            .dispatch("Login", this.loginForm)
            .then((res) => {
              localStorage.setItem("isopen", false);
              localStorage.setItem("isBanks", true);
              this.fullscreenLoading = false;
              this.$store.dispatch("GetInfo").then((response) => {
                if (response.data.loginType == 1) {
                  this.$router.push({
                    path: "/specialMember",
                  });
                } else {
                  if (response.data.registerShare == 0) {
                    this.$router.push({
                      path: "/shoppingMall",
                      query: { id: 100, idTh: 21 },
                    });
                  } else if (response.data.registerFans == 0) {
                    this.$router.push({
                      path: "/shoppingMall",
                      query: { id: 100, idTh: 7 },
                    });
                  } else {
                    localStorage.setItem(
                      "pkCountry",
                      response.data.pkSettleCountry
                    );
                    this.$router
                      .push({ path: this.redirect || "/" })
                      .catch(() => {});
                  }
                }
              });
            })
            .catch(() => {
              this.getCode();
              this.fullscreenLoading = false;
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  // background: url("../assets/images/loginBgd.png") no-repeat;
  background: url("../assets/images/login-bg.png") no-repeat;
  height: 100vh;
  background-size: 100% 100%;
  position: relative;
  overflow: hidden;
  .page-title {
    color: #fff;
    font-size: 40px;
    font-weight: bold;
    position: absolute;
    left: 180px;
    top: 100px;
    letter-spacing: 3px;
  }
}
.local {
  width: 80px;
  height: 80px;
  position: absolute;
  top: 43.5%;
  left: 50%;
}
.lang-wrap {
  position: absolute;
  height: 100%;
  margin-top: 250px;
  right: 138px;
  .lang-active-name,
  .el-icon--right {
    color: #fff;
    cursor: pointer;
  }
}
.kuang {
  ::v-deep .el-input__inner {
    border: 0;
    background: rgba(213, 213, 213, 0.3);
    border-radius: 8px;
    height: 63px;
  }
  ::v-deep .el-form-item__content {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  ::v-deep .el-form-item__label {
    font-size: 18px;
    color: #333333;
    line-height: 24px;
  }
}

.kuang {
  width: 318px;
  height: 608px;
  background: #ffffff;
  border-radius: 10px;
  position: absolute;
  right: 138px;
  // top: 236px;
  top: 285px;
  padding: 0 90px;
}
.tit1 {
  font-size: 22px;
  font-weight: bold;
  color: #2d2d2d;
  letter-spacing: 1px;
  margin: 40px 0;
  text-align: center;
}
.login-code {
  width: 33%;
  height: 38px;
  img {
    cursor: pointer;
    height: 38px;
  }
}

.demo-ruleForm {
  padding-bottom: 21px;
}
.sumBtn {
  // background: #cb2b2b;
  // border-radius: 10px;
  // height: 66px;
  // font-size: 22px;
  // font-weight: bold;
  // color: #ffffff;
  // line-height: 66px;
  // letter-spacing: 1px;
  // text-align: center;
  // cursor: pointer;
  width: 100%;
  // padding-top: 15px;
  //   padding-bottom: 15px;
  font-size: 20px;
  font-weight: bold;
}
.pr {
  position: relative;
}
.pa {
  position: absolute;
  right: 0;
  bottom: -32px;
  font-size: 12px;
  cursor: pointer;
  color: #999999;
}
.righTxt {
  // margin-bottom: 25px;
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  cursor: pointer;
  line-height: 63px;
}
.changePwd {
  ::v-deep .el-input__inner {
    // border: 0;
    // background: rgba(213, 213, 213, 0.3);
    // border-radius: 8px;
    height: 63px;
  }
  ::v-deep .el-form-item__label {
    line-height: 63px;
  }
  ::v-deep .el-input__suffix {
    line-height: 63px;
  }
  ::v-deep .el-icon-view {
    line-height: 63px;
  }
}
.hqyzm1 {
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #0099ff;
  cursor: pointer;
  margin-right: 10px;
  font-style: normal;
}
.hui {
  opacity: 0.5;
}
.title {
  position: absolute;
  color: #fff;
  font-size: 75px;
  font-weight: 600;
  // background: #0e1938;
  letter-spacing: 10px;
  left: 0%;
  right: 0%;
  text-align: center;
  // transform: translateX(-50%);
  top: 0%;
  height: 100px;
  line-height: 200px;
}
</style>
